import { type FunctionComponent } from 'react';
import React from 'react';

import { type GenericFieldProps } from './GenericField';
import GenericField from './GenericField';

export interface InputTextFieldProps extends Omit<GenericFieldProps, 'control'> {
    type?: string;
    name?: string;
}

const InputTextField: FunctionComponent<InputTextFieldProps> = (props) => {
    return (
        <GenericField
            {...props}
            control={(controlProps) => <input type={props.type || 'text'} {...controlProps} />}
            controlModifiers={{ input: true, 'input-text': true, ...props.controlModifiers }}
        />
    );
};

export default InputTextField;
